import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { STANDARD_TO_PREMIUM_TRAIT_ELIGIBILITY } from './standard-to-premium-traits';

function getProductTraitEligibility(context: EditionAwarenessContextType): boolean {
	const traitKey = STANDARD_TO_PREMIUM_TRAIT_ELIGIBILITY[context.product];
	return traitKey ? Boolean(context[traitKey]) : false;
}

export function isEligibleForStandardToPremium(context: EditionAwarenessContextType): boolean {
	const {
		edition,
		isInCollection,
		isInTrial,
		isInPredunning,
		userRoles,
		hasDismissedButton,
		onDismissButton,
	} = context;

	return Boolean(
		isEditionOneOf(edition, ['standard']) &&
		// This trait will also check the supported products
		getProductTraitEligibility(context) &&
		userRoles?.includes('SITE_ADMIN') &&
		!isInTrial &&
		!isInPredunning &&
		hasDismissedButton === false &&
		typeof onDismissButton === 'function' &&
		// Paid sites outside a collection may have no entitlement returned by the query filter,
		// leaving collection status UNKNOWN. Requiring NOT_IN_COLLECTION would exclude those sites.
		(fg('ea_remove_twc_standard_to_premium') ? isInCollection !== 'IN_COLLECTION' : true),
	);
}
